import { useCallback, useState } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import type { AgentNodeFormSchemaType } from './agency-node-form.schema'

interface UseAgentNodeUnsavedChangesProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  onOpenChange: (isOpen: boolean) => void
}

export const useAgentNodeUnsavedChanges = ({
  form,
  onOpenChange,
}: UseAgentNodeUnsavedChangesProps) => {
  const [isUnsavedDialogOpen, setIsUnsavedDialogOpen] = useState(false)

  const handleForceClose = useCallback((): void => {
    form.reset()
    setIsUnsavedDialogOpen(false)
    onOpenChange(false)
  }, [form, onOpenChange])

  const handleCloseAttempt = useCallback((): void => {
    if (form.formState.isDirty) {
      setIsUnsavedDialogOpen(true)
      return
    }
    onOpenChange(false)
  }, [form.formState.isDirty, onOpenChange])

  const handleUnsavedDialogClose = useCallback((): void => {
    setIsUnsavedDialogOpen(false)
  }, [])

  return {
    isUnsavedDialogOpen,
    handleForceClose,
    handleCloseAttempt,
    handleUnsavedDialogClose,
  }
}
